<div cdkDropListGroup class="drag-drop-container mt-4">
  <div class="cdk-drag-left-title-container">
    <p class="mb-0">
      <strong> {{ leftTitle }} </strong>
    </p>
    <small class="mb-3 d-block" *ngIf="leftSubtitle">
      {{ leftSubtitle }}
    </small>
  </div>
  <div class="cdk-drag-right-title-container">
    <p class="mb-0">
      <strong> {{ rightTitle }} </strong>
    </p>
    <small class="mb-3 d-block" *ngIf="rightSubtitle">
      {{ rightSubtitle }}
    </small>
  </div>
  <div class="cdk-drag-left-list-container">
    <div
      cdkDropList
      [cdkDropListData]="leftList"
      class="cdk-drag-list"
      [ngStyle]="{
        height: itemsAmount * 45 + 'px'
      }"
      cdkDropListSortingDisabled
      (cdkDropListDropped)="onRemoved($event)"
    >
      <div
        class="cdk-drag-empty-list-info"
        *ngIf="!leftList?.length && leftSideEmptyLabel"
      >
        <small class="text-muted text-center">
          {{ leftSideEmptyLabel }}
        </small>
      </div>
      <div
        class="cdk-drag-box cdk-drag-red-box"
        *ngFor="let item of leftList"
        cdkDrag
      >
        <div
          class="cdk-drag-draggable-box"
          cdkDragHandle
          [cdkDragHandleDisabled]="item.isLoading"
        >
          <div class="cdk-drag-box-buttons-container">
            <mat-icon>drag_indicator</mat-icon>
          </div>
          {{ extractLeftDescription(item) }}
        </div>

        <div class="cdk-drag-box-buttons-container" *ngIf="item.isLoading">
          <mat-spinner [diameter]="25" [strokeWidth]="3"></mat-spinner>
        </div>
      </div>
    </div>
  </div>
  <div class="cdk-drag-arrow-left-arrow-right-icon-container">
    <fa-icon [icon]="faArrowRightArrowLeft"></fa-icon>
  </div>

  <div class="cdk-drag-right-list-container">
    <div
      class="cdk-drag-list"
      cdkDropList
      [cdkDropListData]="rightList"
      (cdkDropListDropped)="onAdded($event)"
      cdkDropListSortingDisabled
    >
      <div
        class="cdk-drag-empty-list-info"
        *ngIf="!rightList?.length && rightSideEmptyLabel"
      >
        <small class="text-muted text-center">
          {{ rightSideEmptyLabel }}
        </small>
      </div>
      <div
        class="cdk-drag-box cdk-drag-green-box"
        *ngFor="let item of rightList"
        cdkDrag
      >
        <div
          class="cdk-drag-draggable-box"
          cdkDragHandle
          [cdkDragHandleDisabled]="item.isLoading"
        >
          <div class="cdk-drag-box-buttons-container">
            <mat-icon>drag_indicator</mat-icon>
          </div>
          {{ extractRightDescription(item) }}
        </div>
        <div class="cdk-drag-box-buttons-container" *ngIf="item.isLoading">
          <mat-spinner [diameter]="25" [strokeWidth]="3"></mat-spinner>
        </div>
        <ng-container
          *ngIf="moreActionsTemplate"
          [ngTemplateOutlet]="moreActionsTemplate"
          [ngTemplateOutletContext]="{ item: item }"
        ></ng-container>
      </div>
    </div>
  </div>
</div>

<ng-content></ng-content>
